<div class="d-flex flex-column gap-1">
    <div class="d-flex align-items-center">
        <div class="form-group pe-3">
            <label for="inputStartDate">Filter start date</label>
            <dx-date-box id="inputStartDate"
                         style="width: 200px"
                         name="inputStartDate"
                         [value]="startDate"
                         [max]="endDate"
                         (valueChange)="onStartDateChanged($any($event))"></dx-date-box>
        </div>

        <div class="form-group pe-3">
            <label for="inputEndDate">Filter end date</label>
            <dx-date-box id="inputEndDate"
                         style="width: 200px"
                         name="inputEndDate"
                         [value]="endDate"
                         [min]="startDate"
                         (valueChange)="onEndDateChanged($any($event))"></dx-date-box>
        </div>

        <i class="mx-3 fal fa-arrow-left-from-line"></i>

        <div class="form-group pe-3">
            <label for="inputDateRangePreset">Preset ranges</label>
            <dx-select-box id="inputDateRangePreset"
                           style="width: 200px"
                           name="inputDateRangePreset"
                           displayExpr="text"
                           valueExpr="value"
                           [dataSource]="DateRangePresets"
                           [value]="selectedDateRangePreset"
                           [showClearButton]="true"
                           placeholder="Select range"
                           (onValueChanged)="onDateRangePresetChanged($any($event).value)"></dx-select-box>
        </div>
    </div>

    <div class="d-flex w-100 gap-3">
        <button adaptButtonIcon="fal fa-fw fa-sign-in"
                class="btn btn-primary"
                data-test="submit-btn"
                type="button"
                (click)="onFetchClicked()">FETCH!</button>

        @if (!organisation) {
            <button class="ms-auto btn btn-link"
                    adaptButtonIcon="fal fa-people-arrows"
                    (click)="expandPeopleGroups()">Expand people</button>
            <button class="btn btn-link"
                    adaptButtonIcon="fal fa-person"
                    (click)="collapsePeopleGroups()">Collapse people</button>
            <button class="btn btn-link"
                    adaptButtonIcon="fal fa-folder-tree"
                    (click)="expandOrganisationGroups()">Expand organisations</button>
            <button class="btn btn-link"
                    adaptButtonIcon="fal fa-folder-arrow-up"
                    (click)="collapseOrganisationGroups()">Collapse organisations</button>
        }
    </div>

    <dx-data-grid [dataSource]="chatAudits"
                  keyExpr="chatAuditId"
                  [allowColumnResizing]="true"
                  [allowColumnReordering]="true"
                  [wordWrapEnabled]="true"
                  [rowAlternationEnabled]="true"
                  [hoverStateEnabled]="true"
                  [showRowLines]="true"
                  [showBorders]="true"
                  [stateStoring]="dxGridWrapperHelper.stateStoringOptions"
                  (onContentReady)="onGridContentReady($event)"
                  (onInitialized)="onGridInitialized($event)">
        <dxo-data-grid-group-panel [visible]="true"></dxo-data-grid-group-panel>
        <dxo-data-grid-column-chooser [enabled]="true"></dxo-data-grid-column-chooser>
        <dxo-data-grid-pager [showPageSizeSelector]="true"
                             [allowedPageSizes]="[10, 25, 50, 100, 250]"> </dxo-data-grid-pager>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-header-filter [visible]="true"></dxo-data-grid-header-filter>

        <dxi-data-grid-column dataField="personId"
                              caption="Person"
                              dataType="number"
                              alignment="left"
                              [groupIndex]="!!organisation ? 0 : 1"
                              groupCellTemplate="personGroupCellTemplate"
                              cellTemplate="personCellTemplate">
            <dxo-data-grid-header-filter [dataSource]="personNames"></dxo-data-grid-header-filter>

            <div *dxTemplate="let item of 'personCellTemplate'">
                <adapt-link-person [personId]="item.data.personId"></adapt-link-person>
            </div>
            <div *dxTemplate="let item of 'personGroupCellTemplate'"
                 class="d-flex w-100 align-items-center">
                <adapt-link-person [personId]="item.data.key"></adapt-link-person>
                <!-- this is currently in USD from openai - exchange rate may vary; so leave it at USD -->
                <span class="ms-auto small text-muted">Total:
                    {{ getPersonGroupTotal(item.data) | currency: "USD" : "symbol" : "1.4-4" }}
                    USD</span>
            </div>
        </dxi-data-grid-column>

        @if (!organisation) {
            <dxi-data-grid-column dataField="organisationId"
                                  caption="Organisation"
                                  dataType="number"
                                  [groupIndex]="0"
                                  cellTemplate="organisationCellTemplate"
                                  groupCellTemplate="orgGroupCellTemplate">
                <dxo-data-grid-header-filter [dataSource]="orgNames"></dxo-data-grid-header-filter>

                <div *dxTemplate="let item of 'organisationCellTemplate'">
                    <ng-container *ngTemplateOutlet="organisationLink; context:{organisationId: item.data.organisationId}"></ng-container>
                </div>
                <div *dxTemplate="let item of 'orgGroupCellTemplate'"
                     class="d-flex w-100 align-items-center">
                    <ng-container *ngTemplateOutlet="organisationLink; context:{organisationId: item.data.key}"></ng-container>
                    <!-- this is currently in USD from openai - exchange rate may vary; so leave it at USD -->
                    <span class="ms-auto small text-muted">Total:
                        {{ organisationTotalCost[item.data.key ?? 0] ?? 0 | currency: "USD" : "symbol" : "1.4-4" }}
                        USD</span>
                </div>

                <ng-template #organisationLink
                             let-organisationId="organisationId">
                    @if (!organisationId) {
                        <span>{{ RunAdaptName }}</span>
                    } @else {
                        <adapt-link-organisation [organisationId]="organisationId"
                                                 [selectTab]="orgSelectTab"></adapt-link-organisation>
                    }
                </ng-template>
            </dxi-data-grid-column>
        }

        <dxi-data-grid-column dataField="chatAuditId"
                              caption="Audit Id"
                              dataType="number"
                              [allowHeaderFiltering]="false"
                              [visible]="false"> </dxi-data-grid-column>
        <dxi-data-grid-column dataField="conversationId"
                              caption="Conversation Id"
                              dataType="string"
                              [allowHeaderFiltering]="false"
                              [visible]="false"> </dxi-data-grid-column>
        <dxi-data-grid-column dataField="subject"
                              dataType="string"
                              caption="Subject"
                              [allowHeaderFiltering]="false"
                              cellTemplate="subjectCellTemplate">
            <div *dxTemplate="let item of 'subjectCellTemplate'"
                 class="d-flex gap-2 justify-content-between align-items-center">
                <span class="subject-span"
                      [class.text-muted]="item.data.deleted">{{ item.data.subject }}</span>
                <button adaptButtonIcon="fal fa-list"
                        class="btn btn-blank"
                        (click)="showConversationDetails(item.data)"></button>
            </div>
        </dxi-data-grid-column>
        <dxi-data-grid-column dataField="modelName"
                              caption="Model"
                              dataType="string"
                              [visible]="false"> </dxi-data-grid-column>
        <dxi-data-grid-column dataField="startTime"
                              dataType="datetime"
                              [format]="DateFormats.globalize.shortdatetime"
                              caption="Start Time"> </dxi-data-grid-column>
        <dxi-data-grid-column dataField="endTime"
                              dataType="datetime"
                              sortOrder="desc"
                              [format]="DateFormats.globalize.shortdatetime"
                              caption="End Time"> </dxi-data-grid-column>
        <dxi-data-grid-column dataField="inputTokens"
                              dataType="number"
                              format="#,##0"
                              [allowHeaderFiltering]="false"
                              caption="Input Tokens"> </dxi-data-grid-column>
        <dxi-data-grid-column dataField="cachedTokens"
                              dataType="number"
                              format="#,##0"
                              [allowHeaderFiltering]="false"
                              caption="Cached Tokens"> </dxi-data-grid-column>
        <dxi-data-grid-column dataField="outputTokens"
                              dataType="number"
                              format="#,##0"
                              [allowHeaderFiltering]="false"
                              caption="Output Tokens"> </dxi-data-grid-column>
        <dxi-data-grid-column dataField="reasoningTokens"
                              dataType="number"
                              format="#,##0"
                              [allowHeaderFiltering]="false"
                              caption="Reasoning Tokens"
                              [visible]="false"> </dxi-data-grid-column>
        <dxi-data-grid-column dataField="totalCost"
                              caption="Cost"
                              dataType="number"
                              [format]="totalCostCurrencyFormat"
                              [allowHeaderFiltering]="false"> </dxi-data-grid-column>
        <dxi-data-grid-column dataField="deleted"
                              caption="Deleted"
                              dataType="boolean"
                              [allowHeaderFiltering]="true"
                              [visible]="false"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="requestType"
                              caption="Request Type"
                              dataType="string"
                              [allowHeaderFiltering]="true"
                              [visible]="false"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="updateTime"
                              dataType="datetime"
                              sortOrder="desc"
                              [format]="DateFormats.globalize.shortdatetime"
                              caption="Update Time"
                              [visible]="false"> </dxi-data-grid-column>

        <dxo-data-grid-summary>
            <dxi-data-grid-total-item column="inputTokens"
                                      summaryType="sum"
                                      displayFormat="Total: {0}"
                                      valueFormat="#,##0"> </dxi-data-grid-total-item>
            <dxi-data-grid-total-item column="cachedTokens"
                                      summaryType="sum"
                                      displayFormat="{0}"
                                      valueFormat="#,##0"> </dxi-data-grid-total-item>
            <dxi-data-grid-total-item column="outputTokens"
                                      summaryType="sum"
                                      displayFormat="{0}"
                                      valueFormat="#,##0"> </dxi-data-grid-total-item>
            <dxi-data-grid-total-item column="reasoningTokens"
                                      summaryType="sum"
                                      displayFormat="{0}"
                                      valueFormat="#,##0"> </dxi-data-grid-total-item>
            <dxi-data-grid-total-item column="totalCost"
                                      summaryType="sum"
                                      displayFormat="{0} USD"
                                      [valueFormat]="totalCostCurrencyFormat"> </dxi-data-grid-total-item>
        </dxo-data-grid-summary>
    </dx-data-grid>
</div>
